const COLOR_SCHEME = {
    default: "default",
    progress: "progress",
};
const TOGGLE = {
    thumbSize: 20,
    thumbOffset: 2,
    trackWidth: 40,
    trackHeight: 24,
    radius: 16,
    animationDuration: "0.3s",
};

export { COLOR_SCHEME, TOGGLE };
//# sourceMappingURL=toggleConstants.js.map
